'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { v4 as uuid } from 'uuid';
import { useAnalyticsPageView } from '../components/PageView/Context';
import { getCleanLocationHref } from '../lib/urlUtils';
import { useAnalytics } from './useAnalytics';
const FEATURE_INTERACTED_EVENT = 'Feature Interacted';
export type TrackFeatureInteractedParams = {
  entityName: string;
  entitySection: string;
  actionType: string;
  parentActivityId?: string;
  itemCopy?: string;
  additionalAttributes?: Record<string, unknown>;
};
export function useTrackFeatureInteracted() {
  const $ = _c(8);
  const {
    analytics,
    deployableName,
    deployableVersion,
    deviceId,
    gitSha
  } = useAnalytics();
  const {
    pageName,
    pageViewId
  } = useAnalyticsPageView();
  let t0;
  if ($[0] !== analytics || $[1] !== deployableName || $[2] !== deployableVersion || $[3] !== deviceId || $[4] !== gitSha || $[5] !== pageName || $[6] !== pageViewId) {
    t0 = t1 => {
      const {
        entityName,
        entitySection,
        actionType,
        parentActivityId,
        itemCopy,
        additionalAttributes
      } = t1;
      const activityId = uuid();
      analytics.track(FEATURE_INTERACTED_EVENT, {
        event_name: FEATURE_INTERACTED_EVENT,
        entity_name: entityName,
        entity_section: entitySection,
        action_type: actionType,
        activity_id: activityId,
        page_name: pageName,
        page_url: getCleanLocationHref(),
        pageview_id: pageViewId,
        deployable_name: deployableName,
        deployable_version: deployableVersion,
        traditional_device_id: deviceId,
        ...(parentActivityId && {
          parent_activity_id: parentActivityId
        }),
        ...(itemCopy && {
          item_copy: itemCopy
        }),
        ...(additionalAttributes && {
          additional_attributes: additionalAttributes
        })
      }, {
        context: {
          app: {
            name: deployableName,
            version: gitSha
          }
        }
      });
      return activityId;
    };
    $[0] = analytics;
    $[1] = deployableName;
    $[2] = deployableVersion;
    $[3] = deviceId;
    $[4] = gitSha;
    $[5] = pageName;
    $[6] = pageViewId;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
}